import { render } from "./blog-grid.vue?vue&type=template&id=4a96c910&scoped=true"
import script from "./blog-grid.vue?vue&type=script&lang=js"
export * from "./blog-grid.vue?vue&type=script&lang=js"

import "./blog-grid.vue?vue&type=style&index=0&id=4a96c910&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a96c910"]])

export default __exports__